import { getApi, postApi, putApi } from "../apiCall";

export const getCommonChatDetails = ({ name }) => {
  let url = `${process.env.REACT_APP_API_URL}/notify/chat/bsbp/connection/${name}`;
  return getApi(url);
};

export const downloadChat = ({ chatId, username }) => {
  const url = `${process.env.REACT_APP_API_URL}/notify/chat/download/${chatId}/${username}/pdf`;
  return getApi(url, {}, false, "blob");
};

export const fileUpload = (payload, id) => {
  let url = `${process.env.REACT_APP_API_URL}/doc/file/upload/BSB/${id}`;
  return postApi(url, payload);
};

export const handleNotifyApi = ({ userId }) => {
  const url = `${process.env.REACT_APP_API_URL}/notify/notification-center/user/${userId}?page=1&limit=10000000000`;
  return getApi(url);
};

export const handleNotifyRead = ({ id }) => {
  const url = `${process.env.REACT_APP_API_URL}/notify/notification-center/${id}/read`;
  return putApi(url);
};

export const markAllRead = ({ userId }) => {
  const url = `${process.env.REACT_APP_API_URL}/notify/notification-center/user/${userId}/read-all`;
  return putApi(url);
};

export const getNotificationCount = ({ userId }) => {
  const url = `${process.env.REACT_APP_API_URL}/notify/notification-center/user/${userId}/count`;
  return getApi(url);
};

export const getConsumerChatByName = (conName) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/capacity/consumer/by-name/${conName}`;
  return getApi(url);
};

export const getGeneratorChatByName = (genName) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/capacity/generator/by-name/${genName}`;
  return getApi(url);
};

export const getBankingChatByName = (genName) => {
  let url = `${process.env.REACT_APP_API_URL}/banking/listing/by-name/${genName}`;
  return getApi(url);
};
